import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { FrontendLoggerService } from '../frontend-logger.service';
import {
  AlertDetail,
  AlertFilters,
  AlertsPage,
  KnowledgeDashboard,
} from 'src/app/models/alerts/alerts.model';

/**
 * R6 — cliente HTTP de la API de alertas de conocimiento (AlertsController) y del dashboard
 * read-only. Rutas exactas del controller. La identidad viaja por JWT; `ApiService` sanea params
 * vacíos. La bandeja es READ + revisión (acknowledge/snooze/dismiss/resolve); nunca muta el
 * documento ni la evidencia de origen.
 */
@Injectable({ providedIn: 'root' })
export class AlertsService {
  constructor(
    private readonly api: ApiService,
    private readonly frontendLogger: FrontendLoggerService
  ) {}

  /** GET /api/alerts?status=&severity=&sourceType=&from=&to=&page=&pageSize= */
  getAlerts(filters: AlertFilters = {}): Observable<AlertsPage> {
    this.frontendLogger.info('Listando alertas de conocimiento', 'AlertsService.getAlerts');
    return this.api.get<AlertsPage>('alerts', {
      status: filters.status,
      severity: filters.severity,
      sourceType: filters.sourceType,
      from: filters.from,
      to: filters.to,
      page: filters.page ?? 1,
      pageSize: filters.pageSize ?? 20,
    });
  }

  /** GET /api/alerts/{id} */
  getAlert(alertId: string): Observable<AlertDetail> {
    return this.api.get<AlertDetail>(`alerts/${alertId}`);
  }

  /** POST /api/alerts/{id}/acknowledge */
  acknowledge(alertId: string): Observable<unknown> {
    return this.api.post(`alerts/${alertId}/acknowledge`, {});
  }

  /** POST /api/alerts/{id}/dismiss (razón opcional). */
  dismiss(alertId: string, reason?: string): Observable<unknown> {
    return this.api.post(`alerts/${alertId}/dismiss`, { reason });
  }

  /** POST /api/alerts/{id}/snooze (días opcionales). */
  snooze(alertId: string, days?: number): Observable<unknown> {
    return this.api.post(`alerts/${alertId}/snooze`, { days });
  }

  /** POST /api/alerts/{id}/resolve */
  resolve(alertId: string): Observable<unknown> {
    return this.api.post(`alerts/${alertId}/resolve`, {});
  }

  /** GET /api/dashboards/knowledge — dashboard de conocimiento read-only. */
  getDashboard(): Observable<KnowledgeDashboard> {
    return this.api.get<KnowledgeDashboard>('dashboards/knowledge');
  }
}
